import { Analytics } from '@trello/atlassian-analytics';

import { getChannel } from './getChannel';
import { getSessionId } from './getSessionId';

export const startSession = async () => {
  const channel = await getChannel();

  Analytics.sendOperationalEvent({
    source: 'appStartup',
    action: 'started',
    actionSubject: 'session',
    attributes: {
      channel,
      trelloSessionId: getSessionId(),
    },
  });
};
